import { DetailFlag } from "@gigsync/protocol";
import { t } from "../i18n/t.js";
import { isMessageKey } from "./choices.js";
/** What the memory chips carry; the interview's other picks are `NeedPick` (need-hear.ts). */
export const MemoryPick = {
    /** "Yes": use the remembered answer. */
    use: "use_memory",
    /** "Change": the owner answers the question themselves. */
    own: "own_answer",
    /** "Change rooms" / "Change the area" under the next question, after the agent filled one in. */
    redoDetail: "redo_detail",
    redoArea: "redo_area",
};
const Say = {
    offerDetail: "memory.offer_detail",
    oldDetail: "memory.offer_detail_old",
    filledDetail: "memory.filled_detail",
    offerArea: "memory.offer_area",
    oldArea: "memory.offer_area_old",
    filledArea: "memory.filled_area",
    changeDetail: "memory.change_detail",
    changeArea: "memory.change_area",
};
export const OFFER_CHOICES = [
    { value: MemoryPick.use, key: "memory.use" },
    { value: MemoryPick.own, key: "memory.change" },
];
/** The value as a line names it: yes or no in the reader's language, else as the owner wrote it. */
function valueParts(value) {
    const flag = DetailFlag.safeParse(value);
    return flag.success ? { names: { value: [`flag.${flag.data}`] } } : { params: { value } };
}
/** An area's name key, if the catalog of names has it. */
const areaKey = (area) => {
    const key = `area.${area}`;
    return isMessageKey(key) ? [key] : [];
};
/** The offer (`filled` false) or the note that the agent filled it in (`filled` true). */
export function recalledLine(r, filled) {
    if ("area" in r) {
        const key = filled ? Say.filledArea : r.known.fresh ? Say.offerArea : Say.oldArea;
        return { key, names: { area: areaKey(r.area) } };
    }
    const key = filled ? Say.filledDetail : r.known.fresh ? Say.offerDetail : Say.oldDetail;
    const parts = valueParts(r.known.value);
    return { key, ...parts, names: { ...parts.names, detail: [`detail.${r.question}`] } };
}
/** The chip that reopens a question the agent filled in, labelled in the owner's language. */
export function redoChoice(own, question) {
    if (!question)
        return { value: MemoryPick.redoArea, key: Say.changeArea };
    return { value: MemoryPick.redoDetail, key: Say.changeDetail, params: { detail: t(own, `detail.${question}`) } };
}
//# sourceMappingURL=need-memory.js.map